import AppSidebar from "../../components/AppSidebar";
import AppHeader from "../../components/AppHeader";
import PageHeader from "../../components/PageHeader";
import { useEffect, useState, useCallback } from "react";
import CategoryService from "../../services/CategoryService";
import { toast, ToastContainer } from "react-toastify";
import Pagination from '../../components/Pagination';
import CommonTable from '../../components/CommonTable';
import Filters from '../../components/Filters';
import UseDebounce from '../../hooks/UseDebounce';
import { PageLimit, DebounceDelay } from '../../utils/ConstantUtils';

const ListCategory = () => {

    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const pageLimit = PageLimit;
    const [itemsPerPage, setPageLimit] = useState(pageLimit);
    const offset = (currentPage - 1) * itemsPerPage;
    const [appliedFilters, setAppliedFilters] = useState({});
    const debouncedSearchTerm = UseDebounce(searchTerm, DebounceDelay || 100);

    const columns = [
        { Header: '', accessor: '', sample: 'Sample Data' },
        { Header: '#', accessor: 'id', sample: 'Sample Data' },
        { Header: 'Name', accessor: 'name', sample: 'Sample Data' },
        { Header: 'Description', accessor: 'description', sample: 'Sample Data' },
        { Header: 'Status', accessor: 'status', sample: 'Sample Data' }

    ];
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);
    const [alert, setAlert] = useState(false);
    const [error, setError] = useState('');
    const [selectedRows, setSelectedRows] = useState([]);

    const fetchCategories = useCallback(async () => {
        try {
            const response = await CategoryService.getAll({
                page: currentPage,
                limit: itemsPerPage,
                search: debouncedSearchTerm,
                offset: offset,
                filters: appliedFilters,
            });
            setRows(response?.data?.data?.categories);
            setTotalPages(response?.data?.data?.totalPages);
            setCurrentPage(response?.data?.data?.currentPage);
        } catch (error) {
            console.error("Error in fetching categories", error)
            toast.error(error?.response?.data?.message || error?.message || "Error in fetching categories"); 
            setError(error);
        } finally {
            setLoading(false);
        }
    }, [currentPage, itemsPerPage, debouncedSearchTerm, offset, appliedFilters]);

    useEffect(() => {
        fetchCategories();
        const timer = setTimeout(() => {
            setAlert(false);
        }, 3000);
        return () => clearTimeout(timer);
    }, [appliedFilters, fetchCategories]);

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1);
    };

    const handleItemsPerPageChange = (e) => {
        setCurrentPage(1);
        setPageLimit(e.target.value);
    };

    const handleFilterSubmit = (newFilters) => {
        setAppliedFilters(newFilters);
    };

    const getStatusBadgeClass = (status) => {
        switch (status) {
          case 'active':
            return 'badge bg-success'; 
          case 'inactive':
            return 'badge bg-danger'; 
          default:
            return 'badge bg-dark'; 
        }
      };

    const filterFields = [
        { name: 'name', placeholder: 'Name' , Dropdown : "yes"  },
        { name: 'status', placeholder: 'Status' , Dropdown : "yes"  },

    ];

    return (
        <>
            <AppSidebar />
            <div className="main-content">
                <AppHeader title='Categories' />
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="col-12 ">
                            <PageHeader title="Categories" button_label="Create" link_to="create" className="btn btn-sm btn-primary" />
                            {alert && (
                                <div className="alert alert-danger alert-dismissible fade show" role="alert">
                                    <strong> {error}!</strong>
                                    <button type="button" onClick={() => setAlert(false)} className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                                </div>
                            )}
                            <div className="tab-content">
                                <div className="tab-pane fade show active" id="contactsListPane" role="tabpanel" aria-labelledby="contactsListTab">
                                    <div className="card">
                                        <div className="card-header">
                                            <div className="row align-items-center">
                                                <div className="col">
                                                    <form>
                                                        <div className="input-group input-group-flush input-group-merge input-group-reverse">
                                                            <input
                                                                className="form-control list-search"
                                                                type="search"
                                                                placeholder="Search"
                                                                value={searchTerm}
                                                                onChange={handleSearchChange}
                                                            />
                                                            <span className="input-group-text">
                                                                <i className="fe fe-search" />
                                                            </span>
                                                        </div>
                                                    </form>
                                                </div>
                                                <div className="col-auto me-n3">
                                                    <form>
                                                        <select
                                                            className="form-select form-select-sm form-control-flush"
                                                            value={itemsPerPage}
                                                            onChange={handleItemsPerPageChange}
                                                        >
                                                            <option value="20">20 per page</option>
                                                            <option value="40">40 per page</option>
                                                            <option value="60">60 per page</option>
                                                            <option value="100">100 per page</option>
                                                        </select>
                                                    </form>
                                                </div>
                                                <div className="col-auto">
                                                    {/* Use the Filters component here */}
                                                    <Filters filterFields={filterFields} onApplyFilters={handleFilterSubmit} getFilterService={CategoryService.getCategoryFilter} />
                                                </div>
                                            </div>
                                        </div>
                                        {/* Common Table component*/}
                                        <CommonTable
                                            loading={loading}
                                            rows={rows}
                                            columns={columns}
                                            selectedRows={selectedRows}
                                            setSelectedRows={setSelectedRows}
                                            basePath="categories"
                                            showLimitedOptions={true}
                                            offset={offset}
                                            getStatusBadgeClass = {getStatusBadgeClass}
                                            showCheckboxes = {false}
                                        />
                                        <ToastContainer />
                                        {/* Pagination Component */}
                                        <Pagination
                                            currentPage={currentPage}
                                            totalPages={totalPages}
                                            setCurrentPage={setCurrentPage}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ListCategory;